export class RealtimeConnection {
    constructor(
        readonly contextId: number,
        readonly connection: signalR.HubConnection,
    ) {}

    public closedPermanently: boolean;
    /** The hub's onreconnecting/onreconnected/onclose handlers stack up per call, so they are registered once. */
    public lifecycleHandlersRegistered = false;
    public onRegisterEvents: (RealtimeConnection) => void;
    public onDetachEvents: (RealtimeConnection) => void;
}
